// src/i18n.js
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en/translation.json'
import kn from './locales/kn/translation.json'
import hi from './locales/hi/translation.json'

const STORAGE_KEY = 'tecfin_lang'

const savedLang = localStorage.getItem(STORAGE_KEY) || 'en'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      kn: { translation: kn },
      hi: { translation: hi },
    },
    lng:         savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  })

// Persist language choice
i18n.on('languageChanged', (lang) => {
  localStorage.setItem(STORAGE_KEY, lang)
  // Update html lang attribute for accessibility
  document.documentElement.lang = lang
})

export default i18n
